import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SparePart, CreateSparePartDto, UpdateSparePartDto, SparePartMovement, CreateSparePartMovementDto } from '../models/spare-part.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class SparePartService {
  private http = inject(HttpClient);
  private base = `${apiBase}/inventory/parts`;

  getAll(): Observable<SparePart[]> {
    return this.http.get<SparePart[]>(this.base);
  }

  getById(id: number): Observable<SparePart> {
    return this.http.get<SparePart>(`${this.base}/${id}`);
  }

  create(dto: CreateSparePartDto): Observable<SparePart> {
    return this.http.post<SparePart>(this.base, dto);
  }

  update(id: number, dto: UpdateSparePartDto): Observable<SparePart> {
    return this.http.put<SparePart>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  getMovements(sparePartId: number): Observable<SparePartMovement[]> {
    return this.http.get<SparePartMovement[]>(`${this.base}/${sparePartId}/movements`);
  }

  purchase(dto: CreateSparePartMovementDto): Observable<SparePartMovement> {
    return this.http.post<SparePartMovement>(`${this.base}/purchase`, dto);
  }

  adjust(dto: CreateSparePartMovementDto): Observable<SparePartMovement> {
    return this.http.post<SparePartMovement>(`${this.base}/adjust`, dto);
  }
}
